"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = require("@chakra-ui/button");
const system_1 = require("@chakra-ui/system");
var button_2 = require("@chakra-ui/button");
Object.defineProperty(exports, "ButtonGroup", { enumerable: true, get: function () { return button_2.ButtonGroup; } });
const Button = (0, system_1.forwardRef)((_a, ref) => {
    var { fullWidth } = _a, props = __rest(_a, ["fullWidth"]);
    const width = fullWidth ? '100%' : 'auto';
    return (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ ref: ref, width: width }, props));
});
exports.default = Button;
